function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.91655 13.6243H0.15918V38.8698H16.2485L16.391 33.7522H5.91655V13.6243Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.4518 30.7587C32.4518 32.0987 32.1383 33.0823 31.497 33.681C30.8699 34.294 29.8154 34.5933 28.3475 34.5933C26.8797 34.5933 25.8394 34.294 25.1838 33.681C24.514 33.0823 24.1863 32.0987 24.1863 30.7587V17.0312H18.8992V30.8015C18.8992 33.6667 19.6972 35.805 21.2933 37.202C22.8894 38.5989 25.2408 39.2832 28.3618 39.2832C34.6179 39.2832 37.7531 36.4607 37.7531 30.8015V17.0312H32.466V30.7587H32.4518Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.1814 17.0312H55.0535L52.2746 21.9777L51.0205 24.3725H50.9208L49.6667 21.9777L46.9163 17.0312H40.5176L47.0303 27.5656L40.3608 38.8698H46.6027L49.6524 33.1536L50.9065 30.7017H51.0063L52.2319 33.125L55.3813 38.884H61.4522L54.6688 27.4373L61.2099 17.0312H61.1814Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.0053 30.6874L74.3212 33.3103H74.2215L73.5089 30.6874L68.5924 13.6243H62.2935L70.9295 38.8698H77.2997L85.9357 13.6243H80.0074L74.991 30.6874H75.0053Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.0608 29.7181H101.697V25.6412H93.0608V21.6071H103.364L103.264 17.0312H87.7737V38.884H103.692L103.792 34.3795H93.0465V29.7324L93.0608 29.7181Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M118.071 26.468C117.601 26.8814 116.789 27.0952 115.634 27.0952H112.385V21.3077H115.705C116.86 21.3077 117.658 21.5073 118.114 21.9207C118.57 22.3198 118.798 23.061 118.798 24.1444C118.798 25.2848 118.556 26.0688 118.085 26.4822L118.071 26.468ZM123.358 27.7794C124.014 26.7388 124.342 25.4416 124.342 23.8878C124.342 21.55 123.629 19.8252 122.19 18.699C120.75 17.5729 118.598 17.017 115.705 17.017H107.098V38.8698H112.385V30.9583H115.677L119.639 38.8698H125.909L120.551 29.9177C121.776 29.5328 122.703 28.82 123.358 27.7794Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.745 38.8698H134.203V17.0312H128.745V38.884V38.8698Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M137.153 17.0312L137.053 21.6498H143.281V38.884H148.668V21.6356H154.867L154.767 17.017H137.153V17.0312Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M167.479 25.0995L166.425 27.5941H166.325L165.242 25.0995L161.508 17.017H155.48L163.575 31.8563V38.8555H169.033V31.8563L176.956 17.017H171.127L167.465 25.0995H167.479Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M182.357 26.4538L189.597 33.7238L196.836 26.4538L189.597 19.1837L182.357 26.4538Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M196.266 40.0957C195.71 40.0957 195.169 39.8819 194.741 39.4543C193.901 38.6132 193.901 37.2305 194.741 36.3894L204.632 26.4537L194.513 16.2757C193.673 15.4347 193.673 14.0519 194.513 13.2109C195.354 12.3699 196.722 12.3699 197.563 13.2109L209.206 24.9142C209.605 25.3276 209.833 25.8693 209.833 26.4395C209.833 27.0097 209.605 27.5656 209.206 27.979L197.791 39.4543C197.378 39.8819 196.822 40.0957 196.266 40.0957Z",
  fill: "#8A9EAF"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M202.465 46.5105C201.909 46.5105 201.368 46.2966 200.94 45.8832C200.099 45.0422 200.099 43.6595 200.94 42.8184L217.215 26.4537L200.954 10.1033C200.114 9.26228 200.114 7.87955 200.954 7.03851C201.795 6.19747 203.163 6.19747 204.004 7.03851L221.789 24.9285C222.188 25.3419 222.416 25.8835 222.416 26.4537C222.416 27.0239 222.188 27.5799 221.789 27.979L203.99 45.8832C203.562 46.3109 203.021 46.5105 202.465 46.5105Z",
  fill: "#C7CFD4"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M208.821 52.7684C208.266 52.7684 207.724 52.5545 207.297 52.1269C206.456 51.2859 206.456 49.9031 207.297 49.0621L229.799 26.4395L207.297 3.8169C206.456 2.97586 206.456 1.59313 207.297 0.752089C208.137 -0.088953 209.506 -0.088953 210.346 0.752089L234.373 24.9142C234.772 25.3276 235 25.8693 235 26.4395C235 27.0097 234.772 27.5656 234.373 27.9648L210.361 52.1269C209.933 52.5545 209.391 52.7684 208.836 52.7684H208.821Z",
  fill: "white"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 53,
    viewBox: "0 0 235 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b3b747e9.svg";
export { ForwardRef as ReactComponent };